var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2783 4.02051C6.96461 4.02051 4.27832 6.7068 4.27832 10.0205C4.27832 13.3342 6.96461 16.0205 10.2783 16.0205C13.592 16.0205 16.2783 13.3342 16.2783 10.0205C16.2783 6.7068 13.592 4.02051 10.2783 4.02051ZM2.27832 10.0205C2.27832 5.60223 5.86004 2.02051 10.2783 2.02051C14.6966 2.02051 18.2783 5.60223 18.2783 10.0205C18.2783 11.8692 17.6512 13.5715 16.5982 14.9262L21.9854 20.3134C22.376 20.7039 22.376 21.3371 21.9854 21.7276C21.5949 22.1181 20.9617 22.1181 20.5712 21.7276L15.184 16.3404C13.8293 17.3934 12.127 18.0205 10.2783 18.0205C5.86004 18.0205 2.27832 14.4388 2.27832 10.0205Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.0b2c6b7877b7160ed9b27597b5cdbd6d.svg";
export { ForwardRef as ReactComponent };